import { useState } from "react";

export const useRoutingNumberValidation = () => {
  const [routingNumber, setRoutingNumber] = useState("");
  const [routingError, setRoutingError] = useState("");

  // ABA checksum validation
  const validateRouting = (num) => {
    // must be exactly 9 digits
    if (!/^\d{9}$/.test(num)) {
      setRoutingError("Please enter a valid 9-digit routing number.");
      return false;
    }

    // checksum logic
    const digits = num.split("").map(Number);
    const checksum =
      3 * (digits[0] + digits[3] + digits[6]) +
      7 * (digits[1] + digits[4] + digits[7]) +
      (digits[2] + digits[5] + digits[8]);

    if (checksum % 10 !== 0) {
      setRoutingError("Invalid routing number. Please check again.");
      return false;
    }

    setRoutingError("");
    return true;
  };

  // onChange handler
  const handleRoutingChange = (value) => {
    // Allow only digits
    const cleanValue = value.replace(/\D/g, "");
    setRoutingNumber(cleanValue);

    if (cleanValue.length === 9) {
      validateRouting(cleanValue);
    } else {
      setRoutingError("Routing number must be 9 digits.");
    }
  };

  return {
    routingNumber,
    routingError,
    handleRoutingChange,
    validateRouting,
    setRoutingNumber
  };
};
